// Stateful navigation helper - salva/ripristina stato UI in sessionStorage
// SAFE-BY-DESIGN: qui vengono salvati SOLO filtri UI, scroll position, pagination,
// nomi di scope UI. NON salvare mai token/JWT/PII/segreti in questa cache.
// Nessuna informazione sensibile viene serializzata dai callers attuali (verificato).
const KEY_PREFIX = "cantieri_nav:";

export function saveState(scope, state) {
  try { sessionStorage.setItem(KEY_PREFIX + scope, JSON.stringify({ ...state, _ts: Date.now() })); }
  catch (e) { console.warn("navState.saveState failed:", e?.message || e); }
}

export function loadState(scope) {
  try {
    const raw = sessionStorage.getItem(KEY_PREFIX + scope);
    if (!raw) return null;
    const s = JSON.parse(raw);
    // 30 min TTL
    if (Date.now() - (s._ts || 0) > 30 * 60 * 1000) { sessionStorage.removeItem(KEY_PREFIX + scope); return null; }
    return s;
  } catch (e) {
    console.warn("navState.loadState failed:", e?.message || e);
    return null;
  }
}

export function clearState(scope) {
  try { sessionStorage.removeItem(KEY_PREFIX + scope); }
  catch (e) { console.warn("navState.clearState failed:", e?.message || e); }
}

// scroll snapshot su elemento
export function snapshotScroll(scope, extra = {}) {
  saveState(scope, { scrollY: window.scrollY, ...extra });
}

export function restoreScroll(scope) {
  const s = loadState(scope);
  if (s?.scrollY != null) {
    // deferred restore per lasciare che il contenuto renderizzi
    requestAnimationFrame(() => window.scrollTo({ top: s.scrollY, behavior: "instant" }));
  }
  return s;
}
